import Typography from "@material-ui/core/Typography";
import React from "react";

export const Description: React.FC = ({ children }) => (
  <Typography variant="body2" color="textSecondary">
    {children}
  </Typography>
);
